// extracted by mini-css-extract-plugin
export var actionButton = "_my-0";
export var actionMenuContainer = "_my-i";
export var bubble = "_my-2";
export var bubbleActionMenu = "_my-j";
export var bubbleContext = "_my-6";
export var bubbleItems = "_my-7";
export var customer = "_my-3";
export var divider = "_my-8";
export var fileList = "_my-9";
export var hiddenComment = "_my-o";
export var infoAbove = "_my-a";
export var internal = "_my-4";
export var lightActionButton = "_my-1";
export var link = "_my-b";
export var merchant = "_my-5";
export var message = "_my-c";
export var profilePicture = "_my-e";
export var quillToolbarContainer = "_my-f";
export var senderDate = "_my-g";
export var senderDateCustomer = "_my-h";
export var senderName = "_my-d";
export var time = "_my-k";
export var uploadedImage = "_my-l";
export var username = "_my-m";
export var xsmall = "_my-n";